import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models'

import type { SchemaNode } from '../../models'
import type { SchemaObjectSpecific, TypedSchema } from '@rehaje/core'

export class SchemaObjectNode extends ValuableNode {
  @reactive('shallow')
  additionalProperties?: TypedSchema

  @fromSpecific()
  @reactive()
  maxProperties?: number

  @fromSpecific()
  @reactive()
  minProperties?: number

  @fromSpecific()
  @reactive('shallow')
  properties: SchemaNode[] = []

  @reactive('computed')
  get propertyKeys() {
    return this.properties
      .filter((child) => child instanceof ValuableNode)
      .map((node) => node.name) as string[]
  }

  constructor(specific: SchemaObjectSpecific) {
    super(specific)
    this.additionalProperties = specific.additionalProperties
  }
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Object': SchemaObjectNode
  }
}
